module.exports = __webpack_public_path__ + "feafe7daa8a9503fcfa5e7835ea1f08d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/large-s.png
// module id = 2203
// module chunks = 0